const gridItemCls = '.grid-item';

export default {
    grid: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        margin: 0,
        padding: 0,
    },
    'grid--no-wrap': {
        flexWrap: 'nowrap',
    },
    'grid--reverse': {
        flexDirection: 'row-reverse',
    },
    ...[
        'flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'space-evenly',
    ].reduce((acc, item) => {
        acc[`grid--justify-${item}`] = { justifyContent: item };
        return acc;
    }, {}),
    ...[
        'stretch', 'flex-start', 'flex-end', 'center', 'baseline'
    ].reduce((acc, item) => {
        acc[`grid--align-${item}`] = { alignItems: item };
        return acc;
    }, {}),
    ...[
        'stretch', 'flex-start', 'flex-end', 'center', 'space-between', 'space-around'
    ].reduce((acc, item) => {
        acc[`grid--content-${item}`] = { alignContent: item };
        return acc;
    }, {}),
    ...[
        ['row', 'wrap'],
        ['row-reverse', 'wrap'],
        ['column', 'nowrap'],
        ['column-reverse', 'nowrap'],
    ].reduce((acc, item) => {
        const dir = item[0];
        const wrap = item[1];
        const clsPfx = 'grid--direction';
        const clBasis = { flexBasis: 0 };
        acc[`${clsPfx}-${dir}`] = {
            flexDirection: dir,
            flexWrap: wrap,
        };
        acc[`${clsPfx}-column > ${gridItemCls}`] = clBasis;
        acc[`${clsPfx}-column-reverse > ${gridItemCls}`] = clBasis;
        return acc;
    }, {}),
    ...[
        ['s', 4],
        ['sm', 12],
        ['m', 8],
        ['l', 16],
    ].reduce((acc, item) => {
        const label = item[0];
        const value = `${item[1]}px`;
        acc[`grid--gutters-${label}`] = {
            marginLeft: `-${value}`,
            [`& > ${gridItemCls}`]: {
                paddingLeft: value,
            }
        };
        return acc;
    }, {}),
};